import { useEffect, useState } from "react";
import { GetUsersOfClinicUsers } from "fe-common/graphql";
import { useClinicContext } from "fe-web-components/clinic/ClinicContext";
import { getCurrentUserEmail } from "@kahunmedical/user-management";

export function useGetUsersOfClinic(clinicId) {
  const [loading, setLoading] = useState(true);
  const [users, setUsers] = useState<GetUsersOfClinicUsers[]>([]);
  const [currentUser, setCurrentUser] = useState(null); // users[0
  const dao = useClinicContext();

  useEffect(() => {
    (async () => {
      setLoading(true);
      const users = await dao.getUsersOfClinic(clinicId);
      setCurrentUser(await getCurrentUserEmail());
      setLoading(false);
      setUsers(users);
    })();
  }, [dao, clinicId]);

  const isKahunUser = currentUser?.indexOf("kahun.com") !== -1;
  return { loading, users, currentUser, isKahunUser };
}
